import { TOGGLE_FLAG_USERS } from '@/store/action-types';

export default function toggleFlagUsers() {
  return {
    type: TOGGLE_FLAG_USERS,
  };
}
